// extracted by mini-css-extract-plugin
export default {"root":"MenuContainer_root__MTAjN","wrapper":"MenuContainer_wrapper__s41Uj","page":"MenuContainer_page__4FJ5n","hidden":"MenuContainer_hidden__qgjCs"};